/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ClientService } from './services/client.service';
import { ClientConfigurationService } from './services/client-configuration.service';
import { ClientManagementService } from './services/client-management.service';
import { DashboardService } from './services/dashboard.service';
import { DocumentService } from './services/document.service';
import { FactorService } from './services/factor.service';
import { IdpQueueService } from './services/idp-queue.service';
import { IdpSubmissionService } from './services/idp-submission.service';
import { IdpSubmissionsDirectService } from './services/idp-submissions-direct.service';
import { LlmConfigurationService } from './services/llm-configuration.service';
import { MonitorService } from './services/monitor.service';
import { RtsService } from './services/rts.service';
import { SearchService } from './services/search.service';
import { UserManagementService } from './services/user-management.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ClientService,
    ClientConfigurationService,
    ClientManagementService,
    DashboardService,
    DocumentService,
    FactorService,
    IdpQueueService,
    IdpSubmissionService,
    IdpSubmissionsDirectService,
    LlmConfigurationService,
    MonitorService,
    RtsService,
    SearchService,
    UserManagementService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
